<template>
  <div class="upload-progress" :class="miniSizeFlag ? 'mini-size' : 'big-size'" v-if="percent">
    <progress :value="mapPercent" max="100"></progress>{{ mapPercent }}%
    <div class="action-btn">
      <el-button v-if="!miniSizeFlag && sceneNameInject == 'attachUpload'" type="primary" size="mini" plain @click="miniSizeFlag = true">最小化</el-button>
      <el-button v-if="mapPercent <= 100" type="danger" size="mini" plain @click="cancelDownload">取消</el-button>
      <span v-else>请稍等……</span>
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    sceneName: { default: 'default' }
  },
  data () {
    return {
      sceneNameInject: this.sceneName,
      miniSizeFlag: false
    }
  },
  props: {
    percent: {
      type: Number,
      default: 0
    }
  },
  computed: {
    mapPercent () {
      return +(this.percent * 100).toFixed(1)
    }
  },
  methods: {
    cancelDownload () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.upload-progress {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  transition: all .3s;
  .el-progress {
    width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .el-progress__text {
    color: #fff;
  }
  .action-btn {
    position: absolute;
    top: 68%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &.big-size {
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
  }
  &.mini-size {
    right: 20px;
    top: 20px;
    width: 240px;
    height: 80px;
    border-radius: 8px;
    .el-progress {
      top: 24px;
      width: 90%;
    }
  }
}
</style>
